import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  async function checkAuth() {
    try {
      const { data } = await api.get('/auth/me');
      setUser(data.user);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }

  async function login(email, password) {
    const { data } = await api.post('/auth/login', { email, password });
    setUser(data.user);
    return data;
  }

  async function logout() {
    await api.post('/auth/logout');
    setUser(null);
  }

  async function changePassword(currentPassword, newPassword) {
    await api.post('/auth/change-password', {
      current_password: currentPassword,
      new_password: newPassword,
    });
    await checkAuth();
  }

  const isAdmin = user?.role === 'Administrador';
  const isMaintenance = user?.role === 'Manutencao';
  // Somente leitura: enxerga tudo, o servidor recusa qualquer escrita dele
  const isAuditor = user?.role === 'Auditoria';
  // `isPrivileged` decide o que o MENU mostra. Auditoria entra porque
  // precisa alcancar as telas de gestao para conferi-las; o que ele nao pode
  // fazer nelas e barrado no servidor, nao escondendo o link.
  const isPrivileged = isAdmin || isMaintenance || isAuditor;

  return (
    <AuthContext.Provider value={{
      user, loading, login, logout, changePassword, checkAuth,
      isAdmin, isMaintenance, isAuditor, isPrivileged,
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be inside AuthProvider');
  return ctx;
}
